/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const ErrorCodeType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  description: PropTypes.string,
  isInformational: PropTypes.bool,
});

export { ErrorCodeType };
